import React, { useState, useEffect } from "react";
import { ReactComponent as NoConnectionIcon } from "@/Icons/no-connection.svg";
import "./offline-banner.scss";

const OfflineBanner: React.FC = () => {
  const [isOffline, setIsOffline] = useState(!navigator.onLine);

  useEffect(() => {
    const handleOffline = () => setIsOffline(true);
    const handleOnline = () => setIsOffline(false);

    window.addEventListener("offline", handleOffline);
    window.addEventListener("online", handleOnline);

    return () => {
      window.removeEventListener("offline", handleOffline);
      window.removeEventListener("online", handleOnline);
    };
  }, []);

  if (!isOffline) return null;

  return (
    <div className="offline-banner">
      <NoConnectionIcon className="offline-banner__icon" />
      <span className="offline-banner__text">No connection</span>
    </div>
  );
};

export default OfflineBanner;
